export function buildImgUrl(u) {
  if (!u) return "";
  if (u.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${u}`;
  return u;
}

export function primaryImg(p) {
  const url = (p?.images && p.images.length > 0 ? p.images[0] : p?.image_url) || "";
  return buildImgUrl(url);
}
